import api from '@/services/api';
import { createRouter, createWebHashHistory } from 'vue-router';
import { Capacitor } from '@capacitor/core';
import { hasSchoolConfig } from '@/services/schoolService';

const routes = [
  {
    path: '/',
    alias: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue')
  },
  {
    path: '/pair-school',
    name: 'SchoolPairing',
    component: () => import('@/views/auth/SchoolPairingView.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/auth/ForgotPassword.vue')
  },
  {
    path: '/otp/:phoneNumber',
    name: 'OTPScreen',
    component: () => import('@/views/auth/OTPScreen.vue'),
    props: true
  },
  {
    path: '/change-password/:token',
    name: 'ChangePassword',
    component: () => import('@/views/auth/ChangePassword.vue'),
    props: true
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/HomeView.vue')
  },
  {
    path: '/publication',
    children: [
      {
        path: '',
        name: 'Publication',
        component: () => import('@/views/publication/PublicationView.vue')
      },
      {
        path: 'detail/:id',
        name: 'PublicationDetail',
        component: () => import('@/views/publication/PublicationDetail.vue')
      }
    ]
  },
  {
    path: '/academic',
    children: [
      {
        path: '',
        name: 'Academic',
        component: () => import('@/views/academic/Academic.vue')
      },
      {
        path: 'rapor',
        name: 'AcademicRapor',
        component: () => import('@/views/academic/RaporPage.vue')
      },
      {
        path: 'study-material',
        name: 'AcademicStudyMaterial',
        component: () => import('@/views/academic/StudyMaterial.vue')
      },
      {
        path: 'course',
        children: [
          {
            path: '',
            name: 'AcademicCourse',
            component: () => import('@/views/academic/Course.vue')
          },
          {
            path: 'test/:course_id',
            name: 'TestCourse',
            component: () => import('@/views/academic/Test.vue')
          },
          {
            path: 'penilaian/:course_id',
            name: 'PenilaianTest',
            component: () => import('@/views/academic/PenilaianTest.vue')
          }
        ]
      },
      {
        path: 'history',
        name: 'AcademicHistory',
        component: () => import('@/views/academic/History.vue')
      },
      {
        path: '/weekly-competency/:subject_id',
        name: 'WeeklyCompetency',
        component: () => import('@/views/academic/WeeklyCompetency.vue')
      },
      {
        path: 'subject-attendance',
        children: [
          {
            path: '',
            name: 'SubjectAttendance',
            component: () => import('@/views/academic/SubjectAttendance.vue')
          },
          {
            path: 'detail/:id',
            name: 'SubjectAttendanceDetail',
            component: () => import('@/views/academic/SubjectAttendanceDetail.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/notification',
    name: 'Notification',
    component: () => import('@/views/notification/NotificationView.vue')
  },
  {
    path: '/absensi',
    name: 'Absensi',
    component: () => import('@/views/home/absensi/AbsensiView.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/home/profile/Profile.vue')
  },
  {
    path: '/absensi-all',
    name: 'AbsensiAll',
    component: () => import('@/views/home/absensi/AbsensiAll.vue')
  },
  {
    path: '/absen-mapel-all',
    name: 'AbsenMapelAll',
    component: () => import('@/views/home/absensi/AbsenMapelAll.vue')
  },
  {
    path: '/academic-report',
    children: [
      {
        path: '',
        name: 'AcademicReport',
        component: () => import('@/views/home/academic_report/AcademicReport.vue')
      },
      {
        path: 'all',
        name: 'AcademicReportAll',
        component: () => import('@/views/home/academic_report/AcademicReportAll.vue')
      }
    ]
  },
  {
    path: '/top-up',
    name: 'TopUp',
    component: () => import('@/views/home/TopUp.vue')
  },
  {
    path: '/atur-limit',
    name: 'AturLimit',
    component: () => import('@/views/home/AturLimit.vue')
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('@/views/home/HistoryView.vue')
  },
  {
    path: '/scan-qr-code',
    name: 'QRCodeScanner',
    component: () => import('@/views/QRCodeScanner.vue')
  },
  {
    path: '/bayar',
    name: 'Bayar',
    component: () => import('@/views/home/Bayar.vue')
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: () => import('@/views/home/schedule/ScheduleView.vue')
  },
  {
    path: '/edit-profile',
    name: 'EditProfile',
    component: () => import('@/views/home/profile/EditProfile.vue')
  },
  {
    path: '/change-password-users',
    name: 'ChangePassword2',
    component: () => import('@/views/home/profile/ChangePassword.vue')
  },
  {
    path: '/close',
    name: 'CloseSelf',
    component: () => import('@/views/CloseSelf.vue')
  },
  {
    path: '/extracurricular',
    name: 'Extracurricular',
    component: () => import('@/views/home/ExtracurricularView.vue')
  },
  {
    path: '/spp-payment',
    redirect: { name: 'OtherPayment' }
  },
  {
    path: '/other-payment',
    name: 'OtherPayment',
    component: () => import('@/views/home/OtherPayment.vue')
  },
  {
    path: '/quick-access',
    children: [
      {
        path: 'absensi',
        name: 'QAIzin',
        component: () => import('@/views/home/quick_access/QAIzin.vue')
      },
      {
        path: 'course',
        name: 'QACourse',
        component: () => import('@/views/home/quick_access/QACourse.vue')
      },
      {
        path: 'tugas',
        name: 'QATugas',
        component: () => import('@/views/home/quick_access/QATugas.vue')
      },
      {
        path: 'sentiment-analytics',
        name: 'SentimentAnalytics',
        component: () => import('@/views/home/quick_access/SentimentAnalytics.vue')
      },
      {
        path: 'ujian',
        name: 'QAUjian',
        beforeEnter: async (to, from, next) => {
          try {
            const res = await api.post('/sso-login-cbt');

            window.location.href = res.data.data;
          } catch (e) {
            console.error(e)
            next(false) // batalin navigasi
          }
        }
      },
      {
        path: 'konseling',
        name: 'QAKonseling',
        component: () => import('@/views/home/quick_access/QABimbinganKonseling.vue')
      },
      {
        path: 'kedisiplinan',
        name: 'QAKedisiplinan',
        component: () => import('@/views/home/quick_access/QABimbinganKonseling.vue')
      },
      {
        path: 'kantin',
        name: 'QAKantin',
        component: () => import('@/views/home/quick_access/QAKantin.vue')
      },
      {
        path: 'ppdb',
        name: 'QAPpdb',
        component: () => import('@/views/home/quick_access/QAPpdb.vue')
      },
      {
        path: 'chat',
        name: 'QAChat',
        component: () => import('@/views/home/quick_access/QAChat.vue')
      },
      {
        path: 'group-chat/:roomId',
        name: 'GroupChatRoom',
        component: () => import('@/views/home/quick_access/GroupChatRoom.vue')
      },
      {
        path: 'academic-calendar',
        name: 'AcademicCalendar',
        component: () => import('@/views/academic/AcademicCalendar.vue')
      }
    ]
  },
  {
    path: '/extracurricular/:id',
    name: 'ExtracurricularDetail',
    component: () => import('@/views/home/ExtracurricularDetail.vue')
  },
  {
    path: '/student-learning-report',
    name: 'StudentLearningReport',
    component: () => import('@/views/academic/StudentLearningReport.vue')
  },
  {
    path: '/student-tahfidz',
    name: 'StudentTahfidz',
    component: () => import('@/views/academic/StudentTahfidz.vue')
  },
  {
    path: '/sso-login',
    name: 'SSOLogin',
    beforeEnter: (to, from, next) => {
      const token = to.query.token;
      import('@/services/api').then(({ default: api }) => {
        api.post('/sso-login', { token }).then(res => {
          localStorage.setItem('token', res.data.data.accessToken);
          localStorage.setItem('user', JSON.stringify(res.data.data.user));
          import('@/store').then(({ default: store }) => {
            store.dispatch('user/fetchProfile');
            store.commit('children/SET_CHILDREN', []);
            store.commit('children/SET_SELECTED_CHILD', null);
            store.commit('children/SET_CHILD_SCHEDULE', null);
            next({ name: 'Home' });
          });
        }).catch(() => {
          next({ name: 'Login' });
        });
      });
    }
  },
  {
    path: '/academic-achievement',
    name: 'AcademicAchievement',
    component: () => import('@/views/academic/AchievementView.vue')
  },
  {
    path: '/survey',
    name: 'QASurvey',
    component: () => import('@/views/home/quick_access/QASurvey.vue')
  },
  {
    path: '/survey-detail/:id',
    name: 'SurveyDetail',
    component: () => import('@/views/home/quick_access/SurveyDetail.vue')
  },
  {
    path: '/mass-payment-history',
    name: 'MassPaymentHistory',
    component: () => import('@/views/home/MassPaymentHistory.vue')
  },
  {
    path: '/payment-processing',
    name: 'PaymentProcessing',
    component: () => import('@/views/home/PaymentProcessing.vue')
  },
  {
    path: '/daily-report',
    name: 'DailyReport',
    component: () => import('@/views/home/quick_access/DailyReport.vue')
  },
  {
    path: '/daily-material',
    name: 'DailyMaterial',
    component: () => import('@/views/home/quick_access/DailyMaterialView.vue')
  },
  {
    path: '/weekly-report',
    name: 'WeeklyReport',
    component: () => import('@/views/academic/WeeklyReport.vue')
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

import { useConfigStore } from '@/stores/useConfigStore';
import { RoleEnum } from '@/enums/RoleEnum';

const routeModuleMap = {
  StudentTahfidz: ['mobile_tahfidz', 'tahfidz.index', 'tahfidz_keagamaan'],
  QAIzin: ['mobile_permission', 'student_attendance.permissionrequest', 'student_attendance_group'],
  QATugas: ['mobile_homework', 'learning-modules-homeworks.index', 'learning_modules_group'],
  QAUjian: ['mobile_cbt', 'sso-login-cbt', 'cbt_group'],
  QAKonseling: ['mobile_counseling', 'student_dicipline.point_history', 'student_dicipline.violation', 'student_dicipline_group'],
  QASurvey: ['mobile_survey', 'survey-form.index', 'survey-submission.index', 'survey_group'],
  SurveyDetail: ['mobile_survey', 'survey-form.index', 'survey-submission.index', 'survey_group'],
  Extracurricular: ['mobile_extracurricular', 'student-group.index'],
  DailyReport: ['mobile_daily_report', 'daily-report.index', 'reports_group'],
  DailyMaterial: ['mobile_daily_material', 'mobile_daily_report', 'daily-report.index', 'reports_group'],
  AcademicStudyMaterial: ['mobile_study_material', 'mobile_daily_report', 'learning_modules_group'],
  WeeklyReport: ['mobile_weekly_report', 'weekly-report.index', 'reports_group'],
  AcademicAchievement: ['mobile_achievement', 'student-achievements.index'],
  OtherPayment: ['mobile_billing', 'bills.index', 'finance_group', 'finance'],
  TopUp: ['mobile_wallet', 'wallet'],
  AturLimit: ['mobile_wallet', 'wallet'],
  QARequestPickup: ['mobile_pickup', 'pickup'],
  QAChat: ['mobile_chat', 'lms-chat.index'],
  GroupChatRoom: ['mobile_chat', 'lms-chat.index'],
  Absensi: ['mobile_attendance', 'student_attendance_group'],
};

router.beforeEach((to, from, next) => {
  // Jika di platform web (bukan native), bypass sepenuhnya halaman scan QR sekolah
  if (!Capacitor.isNativePlatform()) {
    if (to.name === 'SchoolPairing') {
      next({ name: 'Login' });
      return;
    }
  } else {
    // Khusus mobile native: wajib scan QR sekolah jika belum ada konfigurasi
    const isSchoolConfigured = hasSchoolConfig();
    if (!isSchoolConfigured && !['SchoolPairing', 'CloseSelf'].includes(to.name)) {
      next({ name: 'SchoolPairing' });
      return;
    }
  }

  const token = localStorage.getItem('token');
  const publicRoutes = ['Login', 'SchoolPairing', 'ForgotPassword', 'OTPScreen', 'ChangePassword', 'SSOLogin', 'CloseSelf'];

  if (!token && !publicRoutes.includes(to.name)) {
    next({ name: 'Login' }); // Redirect to login if no token
  } else if (token && ['Login', 'ForgotPassword', 'ChangePassword'].includes(to.name)) {
    next({ name: 'Home' }); // Redirect logged-in users away from login page
  } else {
    if (to.name === 'QAUjian') {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const isParent = user?.roles?.some(r => r.name === RoleEnum.PARENTS);
        if (isParent) {
          next({ name: 'Home' });
          return;
        }
      } catch (e) {
        console.error(e);
      }
    }
    const configStore = useConfigStore();
    const requiredSlugs = routeModuleMap[to.name];
    if (requiredSlugs && configStore.isDisabled(requiredSlugs)) {
      next({ name: 'Home' });
      return;
    }
    next(); // Allow navigation if token exists or user is on login page
  }
})

export default router;
